module.exports = __webpack_public_path__ + "img/404.72ec938e.png";